namespace Portico.Models.Legacy {
    export class MemberNumberStatusResultModel {
		redemptions: number;
		memberNumberStatus: string;
		memberNumberStatusId: string;
        bin: string;
        cardActivationDate: Date;
        cardEndDate: Date;
        sponsorNumber: string;
        memberNumber: string;
        groupNumber: string;
        totalBenefitAmount: number;
        remainingBenefitAmount: number;
        totalPaidAmount: number;

        constructor(obj?: Portico.Services.Legacy.CardService.Models.MemberNumberStatusResultModel) {
			this.redemptions = null;
			this.memberNumberStatus = null;
			this.memberNumberStatusId = null;
            this.bin = null;
            this.cardActivationDate = null;
            this.cardEndDate = null;
            this.sponsorNumber = null;
            this.memberNumber = null;
            this.groupNumber = null;
            this.totalBenefitAmount = null;
            this.remainingBenefitAmount = null;
            this.totalPaidAmount = null;

            if (obj) {
				this.redemptions = obj.redemptions || null;
				this.memberNumberStatus = obj.memberNumberStatus || null;
				this.memberNumberStatusId = obj.memberNumberStatusId || null;
                this.bin = obj.bin || null;
                this.cardActivationDate || null;
                this.cardEndDate = obj.cardEndDate || null;
                this.sponsorNumber = obj.sponsorNumber || null;
                this.memberNumber = obj.memberNumber || null;
                this.groupNumber = obj.groupNumber || null;
                this.totalBenefitAmount = obj.totalBenefitAmount || null;
                this.remainingBenefitAmount = obj.remainingBenefitAmount || null;
                this.totalPaidAmount = obj.totalPaidAmount || null;
            }
        }

		toModel(): Portico.Services.Legacy.CardService.Models.MemberNumberStatusResultModel {
			return {
				redemptions: this.redemptions,
				memberNumberStatus: this.memberNumberStatus,
				memberNumberStatusId: this.memberNumberStatusId,
				bin: this.bin,
				cardActivationDate: this.cardActivationDate,
				cardEndDate: this.cardEndDate,
				sponsorNumber: this.sponsorNumber,
				memberNumber: this.memberNumber,
				groupNumber: this.groupNumber,
				totalBenefitAmount: this.totalBenefitAmount,
				remainingBenefitAmount: this.remainingBenefitAmount,
				totalPaidAmount: this.totalPaidAmount,
			};
        }
    }	
}